/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, {
  useEffect, useCallback, useState, useRef,
} from 'react';
import { flushSync } from 'react-dom';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader, Button, InputGroup,
  Nav, NavItem, NavLink, TabContent, TabPane, Collapse,
  Input, Alert, Badge, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import {
  Table, Thead, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import classnames from 'classnames';
import {
  Formik, Field, Form, ErrorMessage, FieldArray, useFormikContext,
  setIn,
} from 'formik';
import * as Yup from 'yup';
import BaseGrid from '../../components/Common/BaseGrid';
import BoxDimsOpportunity from '../../components/Warehouse/BoxDimsOpportunity';
import { changeSidebarType } from '../../store/actions';

import { get, post } from '../../helpers/api_helper';

import { useScanner } from '../../utilities/ScannerContext';

function renderStockIdCell(stockId, pickrouteItem) {
  const uniqueVoidedOrderIds = new Set(
    (pickrouteItem?.order_items || [])
      .filter((orderItem) => Number(orderItem?.order?.void) === 1)
      .map((orderItem) => orderItem.order.id),
  );
  const voidedCount = uniqueVoidedOrderIds.size;

  return (
    <>
      <div>
        {pickrouteItem?.inventory?.id ? (
          <Link to={`/inventory/${pickrouteItem.inventory.id}`}>{stockId}</Link>
        ) : stockId}
      </div>
      {voidedCount > 0 && (
        <Badge color="danger" pill className="mt-1">
          {`${voidedCount} ${voidedCount === 1 ? 'voided order' : 'voided orders'}`}
        </Badge>
      )}
    </>
  );
}

function isPackageFieldComplete(value) {
  if (value == null) {
    return false;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return false;
  }

  return Number(value) > 0;
}

function getAutoLabelFailureMessage(reason, packageSource, detail = null) {
  if (detail) {
    return detail;
  }

  switch (reason) {
    case 'already_shipped':
      return 'This order has already shipped.';
    case 'package_incomplete':
      return packageSource === 'partial_form'
        ? 'Package details are still incomplete.'
        : 'Package details are not available yet.';
    case 'missing_service_mapping':
      return 'The shipping method does not map to a label service yet.';
    case 'auto_rate_shop':
      return 'This order still needs rate shopping before a label can print.';
    case 'address_validation_failed':
      return 'The shipping address needs review before label printing.';
    case 'multiple_ship_methods':
      return 'The included orders do not share one shipping method.';
    case 'order_not_found':
      return 'The latest order details could not be loaded.';
    case 'missing_order_ids':
      return 'No active order is selected for packout.';
    case 'error':
      return detail || 'We could not confirm automatic label readiness right now.';
    default:
      return detail || 'This order still needs the ship page after packout.';
  }
}

function formatReadinessWeight(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return null;
  }

  return `${numericValue.toFixed(2).replace(/\.?0+$/, '')}lbs`;
}

function getReadinessHistorySummary(autoLabelReadiness, t) {
  if (!autoLabelReadiness?.packageSource || !`${autoLabelReadiness.packageSource}`.includes('history')) {
    return null;
  }

  const details = [];

  if (autoLabelReadiness.historicalPackedBy) {
    details.push(`${t('Last packed by')}: ${autoLabelReadiness.historicalPackedBy}`);
  }

  if (autoLabelReadiness.dimensions) {
    details.push(`${t('Dimensions')}: ${autoLabelReadiness.dimensions}`);
  }

  const formattedWeight = formatReadinessWeight(autoLabelReadiness.weight);
  if (formattedWeight) {
    details.push(`${t('Weight')}: ${formattedWeight}`);
  }

  return details.length > 0 ? details.join('  ') : null;
}

function getPackSubmitButtonLabel(isSubmitting, isPickup, t) {
  if (isSubmitting) {
    return isPickup ? t('Concluding...') : t('Packing...');
  }

  return isPickup ? t('Conclude Order') : t('Pack');
}

function waitForNextPaint() {
  return new Promise((resolve) => {
    window.requestAnimationFrame(() => resolve());
  });
}

const normalizePackageDimensions = (dimensions) => {
  if (!Array.isArray(dimensions) || dimensions.length !== 3) return null;

  const values = dimensions.map(Number);
  if (values.some((value) => !Number.isFinite(value) || value <= 0)) return null;

  const [length, width, height] = values.sort((a, b) => b - a);
  return { length, width, height };
};

const parsePackageDimensions = (value) => {
  if (typeof value !== 'string') return null;

  const match = value.match(/^\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*$/i);
  return match ? normalizePackageDimensions(match.slice(1, 4)) : null;
};

const getItemShipWeight = (item) => {
  const unitWeight = Number(item?.inventory?.ship_weight || 0);
  const qty = Number(item?.qty_unshipped || 0);

  if (!Number.isFinite(unitWeight) || unitWeight <= 0 || !Number.isFinite(qty) || qty <= 0) {
    return 0;
  }

  return unitWeight * qty;
};

const getPackoutSuggestedWeight = (items = []) => items.reduce(
  (sum, item) => sum + getItemShipWeight(item),
  0,
);

const getDimensionsKey = (dimensions) => (
  dimensions ? `${dimensions.length}x${dimensions.width}x${dimensions.height}` : null
);

const getItemPackageDimensions = (item) => {
  const kit = (item.pickroute_items || [])
    .find((pickItem) => Number(pickItem?.void) !== 1 && pickItem?.kit)?.kit;
  const packageEntity = kit?.ship_dims ? kit : item.inventory;
  const dimensions = parsePackageDimensions(packageEntity?.ship_dims);
  const entityWeight = Number(packageEntity?.ship_weight || 0);

  return dimensions ? {
    ...dimensions,
    source: packageEntity === kit ? 'kit ship dimensions' : 'item ship dimensions',
    weight: Number.isFinite(entityWeight) && entityWeight > 0 ? entityWeight : 0,
  } : null;
};

const suggestPackageDimensions = (packoutOrders) => {
  const items = packoutOrders.flatMap((packoutOrder) => packoutOrder.items || []);
  if (items.length === 0) return null;
  const suggestedWeight = getPackoutSuggestedWeight(items);

  const activePickrouteItemsByItem = items.map((item) => (
    (item.pickroute_items || []).filter((pickrouteItem) => Number(pickrouteItem?.void) !== 1)
  ));
  const sharedPickItem = activePickrouteItemsByItem.every((pickrouteItems) => (
    pickrouteItems.length === 1
    && pickrouteItems[0].id === activePickrouteItemsByItem[0]?.[0]?.id
  )) ? activePickrouteItemsByItem[0][0] : null;
  const sharedKitDimensions = parsePackageDimensions(sharedPickItem?.kit?.ship_dims);

  if (sharedKitDimensions) {
    const kitWeight = Number(sharedPickItem?.kit?.ship_weight || 0);
    return {
      ...sharedKitDimensions,
      packageName: getDimensionsKey(sharedKitDimensions),
      source: 'kit ship dimensions',
      weight: Number.isFinite(kitWeight) && kitWeight > 0 ? kitWeight : suggestedWeight,
    };
  }

  const itemPackages = items
    .map((item) => ({ item, dimensions: getItemPackageDimensions(item) }))
    .filter(({ dimensions }) => dimensions !== null);
  if (itemPackages.length === 0) return null;

  if (itemPackages.length === 1 && Number(itemPackages[0].item.qty_unshipped || 1) === 1) {
    const { dimensions } = itemPackages[0];
    return {
      ...dimensions,
      packageName: getDimensionsKey(dimensions),
      source: dimensions.source,
      weight: dimensions.weight || suggestedWeight,
    };
  }

  const aggregate = normalizePackageDimensions([
    Math.max(...itemPackages.map(({ dimensions }) => dimensions.length)),
    Math.max(...itemPackages.map(({ dimensions }) => dimensions.width)),
    itemPackages.reduce((sum, { item, dimensions }) => (
      sum + dimensions.height * Number(item.qty_unshipped || 1)
    ), 0),
  ]);
  return {
    ...aggregate,
    packageName: getDimensionsKey(aggregate),
    source: 'stacked item estimate',
    weight: suggestedWeight,
  };
};

function PackV2(props) {
  toastr.options = {
    positionClass: 'toast-top-center',
    newestOnTop: true,
  };

  const { t } = props;

  const cartRef = useRef(null);
  const sciRef = useRef(null);
  const dimsXRef = useRef(null);
  const dimsYRef = useRef(null);
  const dimsZRef = useRef(null);
  const weightRef = useRef(null);
  const scaleDeviceRef = useRef(null);
  const scaleInputListenerRef = useRef(null);

  const { urlOrderId } = useParams();

  const {
    connectScanner, registerListener, removeListener,
  } = useScanner();

  const [inc, setInc] = useState(0);
  const [cartId, setCartId] = useState(null);
  const [order, setOrder] = useState(null);
  const [scannedItem, setScannedItem] = useState(null); // now { raw, nonce }
  const [pendingScanRaw, setPendingScanRaw] = useState(null);
  const [scannedExtraction, setScannedExtraction] = useState(null);
  const [orders, setOrders] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [manifest, setManifest] = useState({});
  const [includedPackoutOrders, setIncludedPackoutOrders] = useState([]);
  const [preparedSiblingOrders, setPreparedSiblingOrders] = useState({});
  const [includingSiblingOrderId, setIncludingSiblingOrderId] = useState(null);
  const [length, setLength] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [lpn, setLpn] = useState('');
  const [pourLabel, setPourLabel] = useState('');
  const [slot, setSlot] = useState('');
  const [listeners, setListeners] = useState(false);
  const [isPickup, setIsPickup] = useState(false);
  const [scaleConnected, setScaleConnected] = useState(false);
  const [hazmatOptions, setHazmatOptions] = useState([]);
  const [suggestedHazmat, setSuggestedHazmat] = useState(0);
  const [pourRequired, setPourRequired] = useState(false);
  const [siblingOrderContext, setSiblingOrderContext] = useState(null);
  const [loadingSiblingOrders, setLoadingSiblingOrders] = useState(false);
  const [showSiblingOrders, setShowSiblingOrders] = useState(false);
  const [packageDimensionsByOrder, setPackageDimensionsByOrder] = useState({});
  const [dimensionSuggestion, setDimensionSuggestion] = useState(null);
  const [autoLabelReadiness, setAutoLabelReadiness] = useState({
    checking: false,
    eligible: false,
    reason: null,
    packageSource: null,
    detail: null,
    dimensions: null,
    weight: null,
    historicalPackedBy: null,
    carrier: null,
    serviceCode: null,
    serviceName: null,
  });
  const [lastAutoPrintedLabel, setLastAutoPrintedLabel] = useState(null);
  const [reprintDrawerOpen, setReprintDrawerOpen] = useState(false);
  const [packSubmitting, setPackSubmitting] = useState(false);
  const [incompletePackModal, setIncompletePackModal] = useState({
    open: false,
    acknowledged: false,
    message: '',
  });
  const pendingIncompletePackOverrideRef = useRef(null);

  const handleScan = (label) => {
    if (label !== null && label !== undefined) {
      if (label.startsWith('|') && label.length > 74) {
        // part scanned
        const nonce = Math.random().toString(36).slice(2, 10);
        setScannedItem({ raw: label, nonce });
        return;
      }

      if (label.startsWith('-')) {
        if (label.length <= 3) {
          // slot scanned
          setSlot(label.substring(1));
        } else {
          setCartId(label.substring(1));
          cartRef.current.value = label.substring(1);
        }
      }

      if (label.startsWith('/')) {
        // extraction sticker scanned
        setScannedExtraction(label.substring(1));
      }

      if (label.match(/(\d{22})$/)) {
        // USPS tracking scanned.  Grab the last 22 as the tracking number
        const trackingNumber = label.match(/(\d{22})$/)[0];
        setPourLabel(trackingNumber);
        return;
      }

      if (label.match(/^[0-9]{1,21}$/)) {
        // LPN scanned
        setLpn(label);
      }
    }
  };

  const loadHazmatOptions = async () => {
    try {
      const options = await get('/api/warehouse/pack/hazmat');

      setHazmatOptions(options);
    } catch (error) {
      toastr.error(error.message, t('Error loading hazmat options'));
    }
  };

  const formatDateTime = (value) => {
    if (!value) return '';

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '';

    return parsed.toLocaleString();
  };

  const buildManifestForOrders = (sourceOrders, baseManifest = {}) => {
    const nextManifest = { ...baseManifest };

    (sourceOrders || []).forEach((sourceOrder) => {
      (sourceOrder?.items || []).forEach((item) => {
        if (!nextManifest[item.id]) {
          nextManifest[item.id] = { qty: 0, lots: [], serials: [] };
        }
      });
    });

    return nextManifest;
  };

  const getCurrentPackoutOrders = () => (order ? [order, ...includedPackoutOrders] : []);

  const getCurrentUserDisplayName = () => {
    try {
      const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
      return authUser.display_name || authUser.displayName || authUser.username || authUser.name || '';
    } catch (error) {
      return '';
    }
  };

  const loadSiblingOrders = async (orderId) => {
    if (!orderId) {
      setSiblingOrderContext(null);
      return;
    }

    try {
      setLoadingSiblingOrders(true);
      const data = await get(`/api/warehouse/pack/order/${orderId}/siblings`);
      setSiblingOrderContext(data);
    } catch (error) {
      toastr.error(error.message, t('Error loading consolidation candidates'));
      setSiblingOrderContext(null);
    } finally {
      setLoadingSiblingOrders(false);
    }
  };

  // Connect to the scanner when the component mounts
  useEffect(() => {
    registerListener(handleScan);
    setListeners(true);
  }, [connectScanner]);

  useEffect(() => {
    const handleWindowFocus = () => {
      if (!listeners) {
        registerListener(handleScan);
      }
    };

    const handleWindowBlur = async () => {
      // Remove listeners immediately when the window loses focus
      removeListener();
      setListeners(false);
    };

    // Initial listener registration
    handleWindowFocus();

    props.changeSidebarType('icon');

    // If the user changes tabs, remove listeners.
    // Since Chrome might connect scanner to multiple tabs now. 12/29/2025 - Emery
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        handleWindowFocus();
      } else {
        handleWindowBlur();
      }
    });

    loadHazmatOptions();

    // Cleanup listeners on component unmount
    return () => {
      handleWindowBlur();
    };
  }, []);

  const loadOrders = async (sci) => {
    try {
      const data = await get(`/api/warehouse/pack/orders/v2/${cartId}?sticker=${encodeURIComponent(sci)}`);

      if (data.length !== 0) {
        setOrders(data);
        setOrder(data[0]);
        setActiveTab(data[0].id.toString());
        setManifest(buildManifestForOrders([data[0]]));
        setIncludedPackoutOrders([]);
        setPreparedSiblingOrders({});
      } else {
        toastr.warning(t('No orders were found in the cart.'));
      }
    } catch (error) {
      toastr.error('Failed to load orders:', error.message);
    }
  };

  const loadOrder = async (oid) => {
    try {
      if (oid === undefined) return;

      const data = await get(`/api/warehouse/pack/order/${oid}`);

      if (data !== '') {
        setOrders([data]);
        setOrder(data);
        setActiveTab(data.id.toString());

        let coreFound = false;
        const mnf = buildManifestForOrders([data]);
        data.items.forEach((item) => {
          if (item.inventory.has_core === 1) {
            coreFound = true;
          }
        });
        setPourRequired(coreFound);
        setManifest(mnf);
        setIncludedPackoutOrders([]);
        setPreparedSiblingOrders({});
      } else {
        toastr.warning(t('Order not found in cart or possibly already shipped!'));
      }
    } catch (error) {
      toastr.error('Failed to load orders:', error.message);
    }
  };

  useEffect(() => {
    if (orders.length > 0) {
      orders.forEach((o) => {
        if (o.id.toString() === activeTab) {
          setOrder(o);

          setIsPickup(o.ship_method.startsWith('Pick-Up'));

          // Update pourRequired based on the current order
          let coreFound = false;
          o.items.forEach((item) => {
            if (item.inventory.has_core === 1) {
              coreFound = true;
            }
          });
          setPourRequired(coreFound);
          setSuggestedHazmat(o.suggested_hazmat || 0);
        }
      });
    } else {
      setSuggestedHazmat(0);
      setSiblingOrderContext(null);
    }
  }, [activeTab, orders]);

  useEffect(() => {
    if (!order?.id) {
      setIncludedPackoutOrders([]);
      setPreparedSiblingOrders({});
    }

    setIncludedPackoutOrders([]);
    setPreparedSiblingOrders({});
  }, [order?.id]);

  useEffect(() => {
    if (order?.id) {
      loadSiblingOrders(order.id);
    } else {
      setSiblingOrderContext(null);
    }
  }, [order?.id]);

  useEffect(() => {
    const siblingCount = (siblingOrderContext?.siblings || []).length;
    setShowSiblingOrders(siblingCount > 0);
  }, [siblingOrderContext]);

  useEffect(() => {
    if (!order?.id) {
      setAutoLabelReadiness({
        checking: false,
        eligible: false,
        reason: null,
        packageSource: null,
        detail: null,
        dimensions: null,
        weight: null,
        historicalPackedBy: null,
        carrier: null,
        serviceCode: null,
        serviceName: null,
      });
      setDimensionSuggestion(null);
      return;
    }

    const manualDimensions = packageDimensionsByOrder[order.id];
    if (manualDimensions?.manual) {
      const suggestedWeight = getPackoutSuggestedWeight([order, ...includedPackoutOrders].flatMap((packoutOrder) => packoutOrder.items || []));
      setLength(manualDimensions.dx);
      setWidth(manualDimensions.dy);
      setHeight(manualDimensions.dz);
      setWeight(suggestedWeight);
      setDimensionSuggestion({ packageName: t('Manual measurements'), source: 'packer-entered' });
      return;
    }

    const suggestion = suggestPackageDimensions([order, ...includedPackoutOrders]);
    if (!suggestion) {
      setLength(0);
      setWidth(0);
      setHeight(0);
      setWeight(0);
      setDimensionSuggestion(null);
      return;
    }

    setLength(suggestion.length);
    setWidth(suggestion.width);
    setHeight(suggestion.height);
    setWeight(suggestion.weight || 0);
    setDimensionSuggestion(suggestion);
  }, [order, includedPackoutOrders]);

  const loadOrderByExtractionSticker = async () => {
    if (cartId !== null && scannedExtraction !== null) {
      const data = await get(`/api/warehouse/pack/orderByExtractionSticker/${scannedExtraction}`);

      if (data !== '') {
        loadOrder(data.id);
      } else {
        toastr.warning(t('Order not found in cart or possibly already shipped!'));
      }

      setScannedExtraction(null);
    }
  };

  const loadOrderByCartSlot = async () => {
    if (slot !== null) {
      // use cart id to ensure no collisions, but not required
      const data = await get(`/api/warehouse/pack/orderByCartSlot/${slot}${cartId === null ? '' : `/${cartId}`}`);

      if (data !== '') {
        loadOrder(data.id);
      } else {
        toastr.warning(t('Order not found in cart or possibly already shipped!'));
      }
    }

    setSlot(null);
  };

  const getKit = async (stockId) => {
    try {
      const data = await get(`/api/inventory/kit/stock/${stockId}`);

      return data;
    } catch (error) {
      toastr.error('Failed to load kit:', error.message);
      return undefined;
    }
  };

  const focusField = (ref) => {
    ref.current.select(); // Select the text
  };

  const parseScaleData = (dataView) => {
    const scaleStatus = dataView.getUint8(0);
    const isStable = scaleStatus === 0x4 || scaleStatus === 0x2;

    if (!isStable) {
      return null;
    }

    const weightModulus = dataView.getUint8(3);
    const weightScaling = dataView.getUint8(4) * 256;
    const scaleWeight = weightModulus + weightScaling;

    let weightInLb = scaleWeight / 100;

    if (dataView.byteLength > 6) {
      switch (dataView.getUint8(6)) {
        case 3:
          weightInLb = scaleWeight * 0.00220462;
          break;
        case 12:
          weightInLb = scaleWeight / 100;
          break;
        default:
          return null;
      }
    }

    return {
      weightInLb,
      isStable,
    };
  };

  const connectToScale = async (setFieldValue) => {
    try {
      if (scaleConnected && scaleDeviceRef.current) {
        if (scaleInputListenerRef.current) {
          scaleDeviceRef.current.removeEventListener('inputreport', scaleInputListenerRef.current);
          scaleInputListenerRef.current = null;
        }

        if (scaleDeviceRef.current.opened) {
          await scaleDeviceRef.current.close();
        }

        scaleDeviceRef.current = null;
        setScaleConnected(false);
        return;
      }

      if (!navigator.hid) {
        throw new Error(t('This browser does not support HID scale connections.'));
      }

      const filters = [{ vendorId: 0x0EB8, productId: 0xF000 }];
      const devices = await navigator.hid.requestDevice({ filters });

      if (devices.length === 0) {
        return;
      }

      const device = devices[0];
      await device.open();
      scaleDeviceRef.current = device;

      let accumulatedData = new Uint8Array(0);

      const concatenateUint8Arrays = (a, b) => {
        const result = new Uint8Array(a.length + b.length);
        result.set(a, 0);
        result.set(b, a.length);
        return result;
      };

      const handleInputReport = (event) => {
        const { data } = event;
        const newData = new Uint8Array(data.buffer);

        if (newData.byteLength === 5) {
          accumulatedData = concatenateUint8Arrays(accumulatedData, newData);

          const dataView = new DataView(accumulatedData.buffer);
          const result = parseScaleData(dataView);
          if (result?.isStable) {
            setFieldValue('weight', result.weightInLb.toFixed(2));
          }

          accumulatedData = accumulatedData.slice(5);
        }
      };

      scaleInputListenerRef.current = handleInputReport;
      device.addEventListener('inputreport', handleInputReport);

      setScaleConnected(true);
    } catch (error) {
      scaleDeviceRef.current = null;
      scaleInputListenerRef.current = null;
      setScaleConnected(false);
      toastr.error(error.message || t('Unable to connect to scale.'));
    }
  };

  useEffect(() => () => {
    const device = scaleDeviceRef.current;
    const listener = scaleInputListenerRef.current;

    if (device && listener) {
      device.removeEventListener('inputreport', listener);
    }

    if (device?.opened) {
      device.close().catch(() => {});
    }
  }, []);

  const focusLpnField = () => {
    window.setTimeout(() => {
      const lpnField = document.getElementsByName('lpn')[0];
      if (lpnField) {
        lpnField.focus();
      }
    }, 0);
  };

  const handleKeyDown = (e, nextFieldName) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default Enter behavior

      const nextField = document.getElementsByName(nextFieldName)[0];
      if (nextField) {
        nextField.focus();
      }

      return false;
    }

    return true;
  };

  useEffect(() => {
    loadOrderByExtractionSticker();
  }, [scannedExtraction]);

  useEffect(() => {
    if (urlOrderId !== null) loadOrder(urlOrderId);
  }, [urlOrderId]);

  useEffect(() => {
    if (slot !== '') {
      loadOrderByCartSlot();
    }
  }, [slot]);

  useEffect(() => {
    if (order && pendingScanRaw) {
      const nonce = Math.random().toString(36).slice(2, 10);
      setScannedItem({ raw: pendingScanRaw, nonce });
      setPendingScanRaw(null);
    }
  }, [order, pendingScanRaw]);

  useEffect(() => {
    const processScannedItem = () => {
      const activePackoutOrders = getCurrentPackoutOrders();
      const packoutItems = activePackoutOrders.flatMap((packoutOrder) => packoutOrder.items || []);

      if (!order) {
        if (scannedItem?.raw && scannedItem.raw.length > 75) {
          setPendingScanRaw(scannedItem.raw);
          loadOrders(scannedItem.raw);
          setScannedItem(null);
        }
        return;
      }

      const stockId = scannedItem.raw.substring(1, 9).trim();
      const serial = scannedItem.raw.substring(15, 75).trim();
      const lot = scannedItem.raw.substring(75).trim();

      const mnf = { ...manifest };
      let found = false;

      // Helper: ensure manifest entry is initialized
      const ensureEntry = (itemId) => {
        if (!mnf[itemId]) {
          mnf[itemId] = { qty: 0, lots: [], serials: [] };
        }
        return mnf[itemId];
      };

      // ---- 1) MATCH DIRECT ORDER ITEMS ----
      const singles = () => {
        packoutItems.some((item) => {
          if (found) return true;

          if (item.inventory_stock_id !== stockId) return false;

          const entry = ensureEntry(item.id);

          if (entry.qty < item.qty_unshipped) {
            mnf[item.id] = {
              qty: entry.qty + 1,
              lots: [...entry.lots, lot],
              serials: [...entry.serials, serial],
            };
            found = true;
            return true; // stop .some()
          }

          return false;
        });
      };

      // ---- 2) KITS
      const tryKit = (kit) => {
        if (!kit || found) return;

        let appliedAny = false;

        kit.items.forEach((kitm) => {
          const matchedOrderItem = packoutItems.find((oi) => {
            if (String(oi.inventory.stock_id) !== String(kitm.stock_id)) return false;

            const isThisKit = oi.inventory.kits?.find((x) => x.stock_id === kit.stock_id) || oi.pickroute_items?.some(
              (x) => x.kit != null && String(x.kit.stock_id) === String(kit.stock_id),
            );

            if (!isThisKit) {
              return false;
            }

            const entry = mnf[oi.id] ?? { qty: 0 };
            return entry.qty < oi.qty_unshipped;
          });

          if (!matchedOrderItem) return;

          const entry = ensureEntry(matchedOrderItem.id);

          mnf[matchedOrderItem.id] = {
            qty: entry.qty + 1,
            lots: [...entry.lots, lot],
            serials: [...entry.serials, serial],
          };

          appliedAny = true;
        });

        found = appliedAny;
      };

      // If not found, get kit (async but returned with .then to avoid generator)
      getKit(stockId).then((kit) => {
        tryKit(kit);

        if (!found) {
          singles();

          if (!found) toastr.info('Item not found in order');

          setScannedItem(null);
        }

        setManifest(mnf);
      });
    };

    if (scannedItem) {
      processScannedItem();
    }
  }, [scannedItem, includedPackoutOrders, order]);

  const includeSiblingInCurrentPackout = async (sibling) => {
    if (!sibling || !order) return;

    if (isPickup || sibling.ship_method?.startsWith('Pick-Up')) {
      toastr.error(t('Pick-up orders cannot be consolidated into this shipment.'));
      return;
    }

    const currentUser = getCurrentUserDisplayName();
    if (
      sibling.pick_summary?.current_packer
      && currentUser
      && sibling.pick_summary.current_packer !== currentUser
    ) {
      toastr.error(t('This order is already being packed by another user.'));
      return;
    }

    try {
      setIncludingSiblingOrderId(sibling.id);
      const preparedOrder = preparedSiblingOrders[sibling.id] || sibling;
      const fullOrder = preparedOrder?.items?.[0]?.pickroute_items
        ? preparedOrder
        : await get(`/api/warehouse/pack/order/${sibling.id}`);

      if (!fullOrder || fullOrder === '') {
        throw new Error('Unable to load the sibling order for packout.');
      }

      setPreparedSiblingOrders((previous) => ({
        ...previous,
        [fullOrder.id]: fullOrder,
      }));
      setIncludedPackoutOrders((previous) => {
        const existingIndex = previous.findIndex((existing) => existing.id === fullOrder.id);

        if (existingIndex >= 0) {
          const next = [...previous];
          next[existingIndex] = fullOrder;
          return next;
        }

        return [...previous, fullOrder];
      });
      setManifest((previous) => buildManifestForOrders([fullOrder], previous));
      toastr.success(t('Consolidated order included in the current packout.'));
    } catch (error) {
      toastr.error(error.message);
    } finally {
      setIncludingSiblingOrderId(null);
    }
  };

  const removeSiblingFromPackout = (siblingId) => {
    setIncludedPackoutOrders((previous) => previous.filter((packoutOrder) => packoutOrder.id !== siblingId));
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const setManualPackageDimension = (field, value, values, setFieldValue) => {
    setFieldValue(field, value);

    if (!order?.id) return;

    const dimensions = {
      dx: field === 'dx' ? value : values.dx,
      dy: field === 'dy' ? value : values.dy,
      dz: field === 'dz' ? value : values.dz,
      manual: true,
    };
    setPackageDimensionsByOrder((previous) => ({
      ...previous,
      [order.id]: dimensions,
    }));
    setDimensionSuggestion({ packageName: t('Manual measurements'), source: 'packer-entered' });
  };

  // Function to open or reuse the shipping window
  function openShippingWindow(data) {
    // Get the window name from localStorage
    const shipWindowName = localStorage.getItem('shipWindow') || `shipWindow_${data.id}`;

    // Try to get a reference to the window by name and check if it's still open
    let shipWindow = window.open('', shipWindowName);

    if (!shipWindow || shipWindow.closed || shipWindow.location.href === 'about:blank') {
      // If the window is not open or is blank, open a new window
      shipWindow = window.open(`/ship/${data.id}`, shipWindowName, 'width=1160,height=800');

      // Store the window name in localStorage for future reference
      localStorage.setItem('shipWindow', shipWindowName);
    } else {
      // If the window is already open, reuse it and navigate to the new URL
      shipWindow.location.href = `/ship/${data.id}`;
    }

    // Focus the window
    shipWindow.focus();
  }

  const reprintLastAutoLabel = async () => {
    if (!lastAutoPrintedLabel?.labelId) {
      return;
    }

    try {
      const printerId = localStorage.getItem('selectedPrinter');

      if (!printerId || printerId === 'null') {
        throw new Error(t('Automatic label printing requires a selected printer.'));
      }

      await post(`/api/orders/ship/print/${printerId}/${lastAutoPrintedLabel.labelId}`, {});
      toastr.success(t('Last auto-printed label sent to printer again.'));
    } catch (error) {
      toastr.error(error.message || t('Unable to reprint the last auto-printed label.'));
    }
  };

  const finalizePackSubmission = async (nv, values, resetForm, printPacklist) => {
    if (!isPickup) {
      const data = await post('/api/warehouse/pack/V2', nv);

      // only one of these windows will open if user picks print packlist and doesn't provide an LPN.
      // so either provide an LPN or don't print a packlist until this is fixed
      if (printPacklist) {
        const authUser = await localStorage.getItem('authUser');
        const { token } = JSON.parse(authUser);

        window.open(`/api/warehouse/pack/packlist/${data.id}?token=${token}`, '_blank');
      }

      if (values.lpn === '' && !data?.auto_label?.shipped) {
        openShippingWindow(data);
      }

      if (Array.isArray(data?.warnings)) {
        data.warnings.forEach((warning) => toastr.warning(warning));
      }

      if (data?.auto_label?.shipped) {
        setLastAutoPrintedLabel({
          labelId: data?.auto_label?.label_id || null,
          trackingNumber: data?.auto_label?.tracking_number || '',
          orders: getCurrentPackoutOrders().map((packoutOrder) => ({
            id: packoutOrder.id,
            reference: packoutOrder.reference,
          })),
          printedAt: new Date().toISOString(),
          printError: data?.auto_label?.print_error || '',
        });
        setReprintDrawerOpen(Boolean(data?.auto_label?.print_error));
        if (data?.auto_label?.print_error) {
          toastr.warning(
            `${t('Shipping label created, but automatic printing needs attention.')}\n\n${data.auto_label.print_error}`,
          );
        }
        toastr.success(
          data?.auto_label?.tracking_number
            ? `${data.auto_label.tracking_number} created`
            : t('Shipping label created'),
        );
      }

      toastr.success('Packed successfully');
    } else {
      const data = await post('/api/warehouse/pack/conclude', nv);

      if (printPacklist) {
        const authUser = await localStorage.getItem('authUser');
        const { token } = JSON.parse(authUser);

        window.open(`/api/warehouse/pack/packlist/${data.id}?token=${token}`, '_blank');
      }

      toastr.success('Concluded successfully');
    }

    setSlot(null);
    setScannedExtraction(null);
    setScannedItem(null);
    setManifest({});
    setIncludedPackoutOrders([]);
    setPreparedSiblingOrders({});
    setOrders([]);
    setOrder(null);
    setLpn('');
    setActiveTab(null);
    setInc((previous) => previous + 1);
    setPourLabel('');
    setPackageDimensionsByOrder({});
    setDimensionSuggestion(null);
    resetForm();
  };

  const openIncompletePackModal = (message, nv, values, resetForm, printPacklist) => {
    pendingIncompletePackOverrideRef.current = {
      nv,
      values,
      resetForm,
      printPacklist,
    };

    setIncompletePackModal({
      open: true,
      acknowledged: false,
      message,
    });
    focusLpnField();
  };

  const closeIncompletePackModal = () => {
    pendingIncompletePackOverrideRef.current = null;
    setIncompletePackModal({
      open: false,
      acknowledged: false,
      message: '',
    });
  };

  const confirmIncompletePackOverride = async () => {
    if (!incompletePackModal.acknowledged || !pendingIncompletePackOverrideRef.current) {
      return;
    }

    if (packSubmitting) {
      return;
    }

    const pendingSubmission = pendingIncompletePackOverrideRef.current;
    pendingIncompletePackOverrideRef.current = null;
    setIncompletePackModal({
      open: false,
      acknowledged: false,
      message: '',
    });

    try {
      flushSync(() => {
        setPackSubmitting(true);
      });
      await waitForNextPaint();
      await finalizePackSubmission(
        pendingSubmission.nv,
        pendingSubmission.values,
        pendingSubmission.resetForm,
        pendingSubmission.printPacklist,
      );
    } catch (error) {
      toastr.error(error.response?.data?.error || error.message);
    } finally {
      setPackSubmitting(false);
    }
  };

  const pack = async (values, resetForm) => {
    if (packSubmitting) {
      return;
    }

    flushSync(() => {
      setPackSubmitting(true);
    });
    await waitForNextPaint();

    try {
      if (scaleConnected && !(Number(values.weight) > 0)) {
        toastr.error(t('Scale-connected packouts require a weight greater than zero.'));
        weightRef.current?.focus();
        return;
      }

      const nv = { ...values, cart: cartId };
      const activePackoutOrders = getCurrentPackoutOrders();

      // Create the items array
      nv.items = [];
      activePackoutOrders.forEach((packoutOrder) => packoutOrder.items.forEach((item) => {
        const { qty = 0, lots = [], serials = [] } = manifest[item.id] || {};
        const lotsToPack = [...lots];
        const serialsToPack = [...serials];
        let remainingQty = qty;

        // Create line items for each lot
        while (remainingQty > 0) {
          let currentLot = '';
          if (lotsToPack.length === 1) {
            // use this lot for all remaining
            // eslint-disable-next-line prefer-destructuring
            currentLot = lotsToPack[0];
          } else if (lotsToPack.length > 1) {
            currentLot = lotsToPack.length > 0 ? lotsToPack.pop() : ''; // Pop a lot or use a blank one
          }

          const lotQty = Math.min(remainingQty, 1); // Each line item gets 1 qty
          nv.items.push({
            order_item_id: item.id,
            qty: lotQty,
            lot: currentLot,
            serial: serialsToPack.pop() || '',
          });
          remainingQty -= lotQty;
        }
      }));

      nv.items = nv.items.filter((x) => x.qty > 0);

      const printPacklist = nv.print_packlist;

      delete nv.dz;
      delete nv.dy;
      delete nv.dx;
      delete nv.print_packlist;

      const totalQty = nv.items.reduce((a, c) => a + c.qty, 0);

      // if (pourRequired && (values.pour_label === null || values.pour_label === '')) {
      //   toastr.error('Return label is required for this order');
      //   return;
      // }

      // eslint-disable-next-line eqeqeq
      if (totalQty == 0) {
        toastr.error(t('Pack qty is zero?'));
        return;
      }

      // check if order is fully packed
      const isFullyPacked = activePackoutOrders.flatMap((packoutOrder) => packoutOrder.items || []).every((item) => {
        const packedQty = nv.items.filter((x) => x.order_item_id === item.id).reduce((a, c) => a + c.qty, 0);
        return packedQty >= item.qty_unshipped;
      });

      if (!isFullyPacked) {
        toastr.error(t('Order is not fully packed'));

        if (`${values.lpn || ''}`.trim() === '') {
          try {
            const readiness = await post('/api/warehouse/pack/auto-label-readiness', {
              order_ids: activePackoutOrders.map((packoutOrder) => packoutOrder.id),
              dx: values.dx,
              dy: values.dy,
              dz: values.dz,
              weight: values.weight,
              items: nv.items.map((item) => ({
                order_item_id: item.order_item_id,
                qty: item.qty,
              })),
            });

            if (!readiness?.eligible) {
              const readinessMessage = readiness?.error || getAutoLabelFailureMessage(
                readiness?.reason,
                readiness?.package_source,
                readiness?.detail,
              );
              openIncompletePackModal(
                `${t('This packout is not complete, and the submitted contents are not approved for direct label printing without an LPN.')}\n\n${t(readinessMessage)}`,
                nv,
                values,
                resetForm,
                printPacklist,
              );
              setPackSubmitting(false);
              return;
            }
          } catch (error) {
            openIncompletePackModal(
              `${t('This packout is not complete, and we could not approve direct label printing without an LPN.')}\n\n${t('Readiness check failed:')} ${error.response?.data?.error || error.message || t('Unknown error')}`,
              nv,
              values,
              resetForm,
              printPacklist,
            );
            setPackSubmitting(false);
            return;
          }
        } else if (confirm(t('Order is not fully packed. Do you want to pack anyway?'))) {
          // continue packing
        } else {
          setPackSubmitting(false);
          return;
        }
      }

      await finalizePackSubmission(nv, values, resetForm, printPacklist);
    } catch (error) {
      toastr.error(error.response?.data?.error || error.message);
    } finally {
      setPackSubmitting(false);
    }
  };

  document.title = 'Pack V2';

  const validationSchema = Yup.object().shape({
    lpn: Yup.string(),
    dimensions: Yup.string(),
    weight: Yup.number(),
    hazmat: Yup.number(),
    pour_label: Yup.string().nullable(),
    // pour_label: Yup.string().when('$pourRequired', {
    //   is: true,
    //   then: (s) => s.required('Pour label is required'),
    //   otherwise: (s) => s.notRequired(),
    // }),
    items: Yup.array().of(Yup.object().shape({
      order_item_id: Yup.number(),
      qty: Yup.number().required().default(0),
      lot: Yup.string().nullable(),
      serial: Yup.string().nullable(),
    })),
  });

  return (
    <div className="page-content pack-v2-page">
      <div className="container-fluid">
        <Row>
          <Col md={order === null ? '8' : '3'}>
            {order && (
              <Card className="border-warning shadow-sm mb-3">
                <CardHeader
                  className="bg-warning bg-soft text-dark border-bottom"
                  onClick={() => setShowSiblingOrders(!showSiblingOrders)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <strong>{t('Potential Order Consolidations')}</strong>
                      <div className="small">
                        {loadingSiblingOrders
                          ? t('Checking for sibling orders...')
                          : `${(siblingOrderContext?.siblings || []).length} ${t('matching orders found for this ship-to')}`}
                      </div>
                    </div>
                    {(siblingOrderContext?.siblings || []).length > 0 && (
                      <Badge color="warning" pill className="ms-auto text-dark">
                        {(siblingOrderContext?.siblings || []).length}
                      </Badge>
                    )}
                    <span className={`mdi ms-2 ${showSiblingOrders ? 'mdi-chevron-up' : 'mdi-chevron-down'}`} />
                  </div>
                </CardHeader>
                <Collapse isOpen={showSiblingOrders}>
                  <CardBody>
                    {(siblingOrderContext?.siblings || []).length > 0 ? (
                      <>
                        <Alert color="warning" className="mb-3">
                          <strong>{t('Heads up:')}</strong>
                          {' '}
                          {t('other unshipped orders appear to share this destination. Review them before you finish packing.')}
                        </Alert>
                        {siblingOrderContext.siblings.map((sibling) => {
                          const itemCount = (sibling.items || []).reduce(
                            (sum, item) => sum + Number(item.qty_unshipped || 0),
                            0,
                          );
                          const carts = [
                            ...new Set(
                              (sibling.items || [])
                                .flatMap((item) => item.pick_summary?.carts || [])
                                .filter(Boolean),
                            ),
                          ];
                          const slots = [
                            ...new Set(
                              (sibling.items || [])
                                .flatMap((item) => item.pick_summary?.slots || [])
                                .filter(Boolean),
                            ),
                          ];
                          const isIncludedInPackout = includedPackoutOrders.some((packoutOrder) => packoutOrder.id === sibling.id);
                          return (
                            <Card key={sibling.id} className="border mb-3">
                              <CardBody className="p-3">
                                <div className="d-flex align-items-start mb-2">
                                  <div>
                                    <div className="fw-bold">
                                      <Link target="_blank" to={`/orders/${sibling.id}`}>
                                        {sibling.reference}
                                      </Link>
                                    </div>
                                    <div className="text-muted small">
                                      {`${sibling.shipTo?.firstname || ''} ${sibling.shipTo?.lastname || ''}`.trim()}
                                    </div>
                                  </div>
                                  <Badge color="info" className="ms-auto">
                                    {`${itemCount} ${t('items remain')}`}
                                  </Badge>
                                </div>
                                <div className="d-flex gap-2 mb-2">
                                  {!isIncludedInPackout && (
                                    <Button color="primary" size="sm" disabled={includingSiblingOrderId === sibling.id} onClick={() => includeSiblingInCurrentPackout(sibling)}>
                                      {includingSiblingOrderId === sibling.id ? t('Including...') : t('Include in Current Packout')}
                                    </Button>
                                  )}
                                  {isIncludedInPackout && (
                                    <>
                                      <Badge color="success" className="align-self-center">
                                        {t('Included in current packout')}
                                      </Badge>
                                      <Button color="light" size="sm" onClick={() => removeSiblingFromPackout(sibling.id)}>
                                        {t('Remove from Packout')}
                                      </Button>
                                    </>
                                  )}
                                </div>
                                <div className="mb-2">
                                  <strong className="fs-5">{t('Cart')}</strong>
                                  <span className="fs-5 fw-bold">
                                    {`: ${carts.length > 0 ? carts.join(', ') : t('Not on cart')}`}
                                  </span>
                                </div>
                                {sibling.pick_summary?.picker_names?.length > 0 && (
                                  <div className="small mb-2">
                                    <strong>{t('Picked by')}</strong>
                                    {`: ${sibling.pick_summary.picker_names.join(', ')}`}
                                  </div>
                                )}
                                {sibling.pick_summary?.route_finished_at && (
                                  <div className="small mb-2">
                                    <strong>{t('Route finished')}</strong>
                                    {`: ${formatDateTime(sibling.pick_summary.route_finished_at)}`}
                                  </div>
                                )}
                                {sibling.pick_summary?.current_packer && (
                                  <div className="small mb-2 text-primary">
                                    <strong>{`${sibling.pick_summary.current_packer} ${t('currently packing cart')}`}</strong>
                                  </div>
                                )}
                                {slots.length > 0 && (
                                  <div className="small mb-2">
                                    <strong>{t('Slots')}</strong>
                                    {`: ${slots.join(', ')}`}
                                  </div>
                                )}
                                <div className="table-responsive">
                                  <Table className="table table-sm table-nowrap mb-0">
                                    <Thead>
                                      <Tr>
                                        <Th>{t('Stock')}</Th>
                                        <Th>{t('Need')}</Th>
                                        <Th>{t('Status')}</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {(sibling.items || []).map((item) => (
                                        <Tr key={item.id}>
                                          <Td>
                                            <div>{item.inventory_stock_id || item.inventory?.stock_id}</div>
                                            <div className="text-muted small">
                                              {item.inventory_part_number || item.inventory?.part_number}
                                            </div>
                                          </Td>
                                          <Td>{item.qty_unshipped}</Td>
                                          <Td>
                                            {item.pick_summary?.status === 'on_cart' && t('On cart')}
                                            {item.pick_summary?.status === 'picked_no_cart' && t('Picking')}
                                            {item.pick_summary?.status === 'not_picked' && t('Not picked')}
                                          </Td>
                                        </Tr>
                                      ))}
                                    </Tbody>
                                  </Table>
                                </div>
                              </CardBody>
                            </Card>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-muted">
                        {loadingSiblingOrders
                          ? t('Looking for other orders at this address...')
                          : t('No same-address sibling orders are waiting right now.')}
                      </div>
                    )}
                  </CardBody>
                </Collapse>
              </Card>
            )}
            <Card>
              <CardHeader className="text-uppercase bg-transparent border-bottom">
                <div className="d-flex align-items-center">
                  <span>{t('Cart Contents')}</span>
                  <div className="ms-auto">
                    <InputGroup>
                      <input
                        type="text"
                        ref={cartRef}
                        className="form-control input-sm"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setCartId(cartRef.current.value ? cartRef.current.value.replace(/^-/, '') : null);
                          }
                          return false;
                        }}
                        value={cartId}
                      />
                      {cartId === null && (
                        <Button color="primary" size="sm" onClick={() => setCartId(cartRef.current.value ? cartRef.current.value : null)}>{t('Load')}</Button>
                      )}
                      {cartId !== null && (
                        <Button
                          color="danger"
                          size="sm"
                          className="bg-soft-danger"
                          onClick={() => {
                            setCartId(null);
                            cartRef.current.value = '';
                          }}
                        >
                          <span className="mdi mdi-close-thick" />
                        </Button>
                      )}
                    </InputGroup>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <>
                  {cartId === null && (
                    <div className="text-center">
                      <h6>{t('Awaiting valid cart scan...')}</h6>
                    </div>
                  )}
                  {cartId !== null && (
                    <div>
                      <Button
                        color="primary"
                        className="btn btn-danger btn-sm mb-3"
                        onClick={async () => {
                          if (confirm(t('Are you sure your cart is empty?'))) {
                            try {
                              await post('/api/warehouse/pack/clear', { cart: cartId });
                              setOrders([]);
                              setInc((previous) => previous + 1);
                            } catch (error) {
                              toastr.error('Failed to clear cart:', error.message);
                            }
                          }
                        }}
                      >
                        {t('Clear Out Cart!')}
                      </Button>
                      <div className="mb-3">
                        <span>
                          Part Search
                        </span>
                        <input
                          type="text"
                          id="part_search"
                          name="part_search"
                          ref={sciRef}
                          className="form-control col-sm-6"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              setScannedItem(e.target.value);
                            }
                          }}
                        />
                      </div>
                      <BaseGrid
                        url="/api/warehouse/pick/items"
                        shouldUpdate={
                          parseInt([...cartId].map((char) => char.charCodeAt(0).toString(36)).join(''), 10) + inc
                        }
                        filters={`pi.cart=${cartId}&pi.void=0`}
                        config={
                          {
                            columns: {
                              id: {
                                label: 'Route',
                                sort: true,
                                format: (y, x) => x.pickroute.id,
                                link: {
                                  to: '/warehouse/pickroute/%pickroute_id%',
                                },
                              },
                              qty: {
                                label: 'Qty',
                              },
                              stock_id: {
                                label: 'Stock ID',
                                sort: true,
                                format: renderStockIdCell,
                              },
                              part_number: {
                                label: 'Part Number',
                                format: (y, x) => {
                                  if (x.inventory === null) {
                                    return x.kit.sku || `KIT-${x.stock_id}`;
                                  }
                                  return x.inventory.part_number;
                                },
                              },
                              lot: {
                                label: 'Lot',
                              },
                              serial: {
                                label: 'Serial',
                              },
                              sticker: {
                                label: 'Sticker',
                              },
                              slot: {
                                label: 'Slot',
                              },
                              actions: {
                                label: props.t('Act'),
                                actions: [
                                  {
                                    key: 'load',
                                    icon: 'mdi mdi-check-circle',
                                    class: 'btn btn-sm btn-primary btn-soft-primary p-1 fs-6',
                                    alt: props.t('Load Order'),
                                    click: (x) => {
                                      const activeOrderItems = x.order_items.filter((y) => Number(y?.order?.void) !== 1);

                                      if (activeOrderItems.map((y) => y.qty_unshipped)
                                        .reduce((a, b) => a + b, 0) === 0) {
                                        toastr.info('Orders already packed');
                                      }
                                      activeOrderItems.forEach((oi) => {
                                        if (oi.qty_unshipped > 0) {
                                          loadOrder(oi.order_id);
                                        }
                                      });
                                    },
                                  },
                                ],
                              },
                            },
                            pagination: {
                              sort: 'id',
                              direction: 'desc',
                              perPage: 50,
                            },
                          }
                        }
                      />
                    </div>
                  )}
                </>
              </CardBody>
            </Card>
          </Col>

          <Col md={order === null ? '4' : '9'}>
            <Formik
              enableReinitialize
              initialValues={{
                lpn: '',
                items: [],
                dx: length,
                dy: width,
                dz: height,
                dimensions: '',
                weight,
                hazmat: suggestedHazmat,
                print_packlist: order && order.packlist === 1,
                pour_label: pourLabel,
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                pack(values, resetForm);
              }}
            >
              {({
                setFieldValue, values, errors,
              }) => (
                <Form id="packForm" autoComplete="off">
                  <AutoLabelReadinessWatcher
                    activeOrderIds={getCurrentPackoutOrders().map((packoutOrder) => packoutOrder.id)}
                    activeOrders={getCurrentPackoutOrders()}
                    dx={values.dx}
                    dy={values.dy}
                    dz={values.dz}
                    weight={values.weight}
                    isPickup={isPickup}
                    setAutoLabelReadiness={setAutoLabelReadiness}
                  />
                  <Row>
                    <Col lg="12">
                      {orders.length > 0 && (
                        <>
                          {getCurrentPackoutOrders()
                            .filter((packoutOrder) => `${packoutOrder.staff_note || ''}`.trim() !== '')
                            .map((packoutOrder) => (
                              <Card className="border-warning shadow-sm mb-3" key={`staff-note-${packoutOrder.id}`}>
                                <CardHeader className="bg-warning bg-soft text-dark border-bottom">
                                  <div className="d-flex align-items-center">
                                    <span className="mdi mdi-note-text-outline fs-4 me-2" aria-hidden="true" />
                                    <strong>{t('Staff Note')}</strong>
                                    <Badge color="warning" pill className="ms-2 text-dark">
                                      {packoutOrder.reference}
                                    </Badge>
                                  </div>
                                </CardHeader>
                                <CardBody>
                                  <div style={{ whiteSpace: 'pre-wrap' }}>
                                    {packoutOrder.staff_note}
                                  </div>
                                </CardBody>
                              </Card>
                            ))}
                          <Nav tabs>
                            {orders.map((o) => (
                              <div>
                                {o.items.reduce((a, b) => a + b.qty_unshipped, 0) > 0 && (
                                  <NavItem key={o.id} style={{ height: '36px' }}>
                                    <NavLink
                                      style={{ cursor: 'pointer' }}
                                      className={classnames({
                                        active: activeTab === o.id.toString(),
                                        'pt-0': activeTab === o.id.toString(),
                                      })}
                                      onClick={() => {
                                        toggle(o.id.toString());
                                      }}
                                    >
                                      {o.reference}
                                      {activeTab === o.id.toString() && (
                                        <>
                                          {' '}
                                          <Button
                                            color="white"
                                            className="btn-sm p-1 fs-5"
                                            onClick={async () => {
                                              setOrders([]);
                                              setOrder(null);
                                              setActiveTab('');
                                              await loadOrder(o.id);
                                            }}
                                          >
                                            <span className="mdi mdi-refresh" />
                                          </Button>
                                        </>
                                      )}
                                    </NavLink>
                                  </NavItem>
                                )}
                              </div>
                            ))}
                          </Nav>
                          <TabContent activeTab={activeTab} className="mb-3 text-muted">
                            {orders.map((o) => (
                              <TabPane
                                tabId={o.id.toString()}
                                key={o.id}
                              >
                                {o.id.toString() === activeTab && (
                                  <Row>
                                    <Col sm="12">
                                      <Card>
                                        <CardBody>
                                          {Number(o.void) === 1 && (
                                            <Alert color="danger">
                                              <strong>{t('Order is voided!')}</strong>
                                              {' '}
                                              This order was canceled and should not be packed.
                                            </Alert>
                                          )}
                                          {o.items.filter((x) => x.substituted !== 0).length > 0 && (
                                            <Alert color="danger">
                                              <span className="mdi mdi-swap-horizontal ds-3" />
                                              {' '}
                                              <strong className="text-dark">
                                                {t('This order contains substitutes!')}
                                              </strong>
                                            </Alert>
                                          )}
                                          <Row>
                                            <Col md="3">
                                              <div className="text-dark">
                                                {t('Order')}
                                                {' '}
                                                <Link target="_blank" to={`/orders/${o.id}`}>{o.reference}</Link>
                                                <Button className="m-1" color="soft-danger" size="sm" onClick={() => { setOrders([]); setOrder(null); setActiveTab(''); setManifest([]); }}>
                                                  <span className="mdi mdi-close-thick" />
                                                </Button>
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col md="12">
                                              <div className="table-responsive">
                                                <Table className="table table-nowrap table-hover table-centered table-nowrap mt-3">
                                                  <Thead>
                                                    <Tr>
                                                      <Th>{t('Image')}</Th>
                                                      <Th className="fs-6">{t('Stock ID/PN/Lot')}</Th>
                                                      <Th>{t('Lots')}</Th>
                                                      <Th>{t('Qty Ordered')}</Th>
                                                      <Th>{t('Qty Needed')}</Th>
                                                      <Th>{t('Pack Qty')}</Th>
                                                    </Tr>
                                                  </Thead>
                                                  <Tbody>
                                                    {order.items.map((oi, idx) => (
                                                      <Tr key={oi.id}>
                                                        <Td className="align-middle">
                                                          <img style={{ maxWidth: '88px', maxHeight: '88px' }} src={oi.inventory.image_url} alt={oi.inventory_part_number} />
                                                        </Td>
                                                        <Td>
                                                          <div style={{ maxHeight: '128px', overflowY: 'auto' }}>
                                                            {oi.pickroute_items.map((pri) => (
                                                              <div>
                                                                {pri.void === 0 && (
                                                                  <div className="mb-2">
                                                                    <div className="text-info me-1 mb-1 fs-5">{pri.stock_id}</div>
                                                                    {pri.kit !== null && (
                                                                      <div className="me-1 mb-1 fs-6">{t('Satisfied by')}</div>
                                                                    )}
                                                                    <h5>
                                                                      {pri.kit ? pri.kit.sku : pri.inventory.part_number}
                                                                    </h5>
                                                                    <div className="text-info me-1 mb-1 fs-5">{pri.lot}</div>
                                                                  </div>
                                                                )}
                                                              </div>
                                                            ))}
                                                          </div>
                                                        </Td>
                                                        <Td className="align-middle">
                                                          {manifest[oi.id] && manifest[oi.id].lots.map((x, index) => (
                                                            <div className="hstack gap-1" key={index}>
                                                              <span className="fs-5">{x}</span>
                                                              <Button
                                                                color="danger"
                                                                size="sm"
                                                                style={{ padding: '1px' }}
                                                                onClick={() => {
                                                                  const nm = { ...manifest };
                                                                  nm[oi.id].lots.splice(index, 1); // Remove the specific lot at the current index
                                                                  setManifest(nm);
                                                                }}
                                                              >
                                                                <span className="mdi mdi-close" />
                                                              </Button>
                                                            </div>
                                                          ))}
                                                        </Td>
                                                        <Td className="align-middle">{oi.qty}</Td>
                                                        <Td className="align-middle">
                                                          <span className={`badge ${oi.qty_unshipped > 1 ? 'p-3 bg-danger fs-4' : 'p-2 bg-info'}`}>
                                                            {oi.qty_unshipped}
                                                          </span>
                                                        </Td>
                                                        <Td className="align-middle">
                                                          <Field
                                                            name={`items[${idx}].qty`}
                                                            type="number"
                                                            onChange={(e) => { const nm = { ...manifest }; nm[oi.id].qty = parseInt(e.target.value, 10); setManifest(nm); }}
                                                            className={`form-control ${manifest[oi.id] && manifest[oi.id].qty > oi.qty_unshipped ? 'is-invalid' : ''} ${manifest[oi.id] && manifest[oi.id].qty === oi.qty_unshipped ? 'bg-success bg-soft text-dark' : ''}`}
                                                            value={manifest[oi.id]?.qty}
                                                          />
                                                        </Td>
                                                      </Tr>
                                                    ))}
                                                  </Tbody>
                                                </Table>
                                              </div>
                                            </Col>
                                          </Row>

                                          {includedPackoutOrders.length > 0 && (
                                            <Row className="mt-4">
                                              <Col md="12">
                                                <h5>{t('Included Consolidated Items')}</h5>
                                                <div className="table-responsive">
                                                  <Table className="table table-nowrap table-hover table-centered table-nowrap mt-3">
                                                    <Thead>
                                                      <Tr>
                                                        <Th>{t('Order')}</Th>
                                                        <Th>{t('Image')}</Th>
                                                        <Th className="fs-6">{t('Stock ID/PN/Lot')}</Th>
                                                        <Th>{t('Lots')}</Th>
                                                        <Th>{t('Qty Ordered')}</Th>
                                                        <Th>{t('Qty Needed')}</Th>
                                                        <Th>{t('Pack Qty')}</Th>
                                                      </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                      {includedPackoutOrders.flatMap((includedOrder) => (
                                                        (includedOrder.items || []).map((oi) => (
                                                          <Tr key={oi.id}>
                                                            <Td className="align-middle">
                                                              <div>{includedOrder.reference}</div>
                                                              <div className="text-muted small">
                                                                {`${includedOrder.shipTo?.firstname || ''} ${includedOrder.shipTo?.lastname || ''}`.trim()}
                                                              </div>
                                                            </Td>
                                                            <Td className="align-middle">
                                                              <img style={{ maxWidth: '88px', maxHeight: '88px' }} src={oi.inventory.image_url} alt={oi.inventory_part_number} />
                                                            </Td>
                                                            <Td>
                                                              <div style={{ maxHeight: '128px', overflowY: 'auto' }}>
                                                                {oi.pickroute_items.map((pri) => (
                                                                  <div>
                                                                    {pri.void === 0 && (
                                                                      <div className="mb-2">
                                                                        <div className="text-info me-1 mb-1 fs-5">{pri.stock_id}</div>
                                                                        {pri.kit !== null && (
                                                                          <div className="me-1 mb-1 fs-6">{t('Satisfied by')}</div>
                                                                        )}
                                                                        <h5>
                                                                          {pri.kit ? pri.kit.sku : pri.inventory.part_number}
                                                                        </h5>
                                                                        <div className="text-info me-1 mb-1 fs-5">{pri.lot}</div>
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                ))}
                                                              </div>
                                                            </Td>
                                                            <Td className="align-middle">
                                                              {manifest[oi.id] && manifest[oi.id].lots.map((x, index) => (
                                                                <div className="hstack gap-1" key={index}>
                                                                  <span className="fs-5">{x}</span>
                                                                  <Button
                                                                    color="danger"
                                                                    size="sm"
                                                                    style={{ padding: '1px' }}
                                                                    onClick={() => {
                                                                      const nm = { ...manifest };
                                                                      nm[oi.id].lots.splice(index, 1);
                                                                      setManifest(nm);
                                                                    }}
                                                                  >
                                                                    <span className="mdi mdi-close" />
                                                                  </Button>
                                                                </div>
                                                              ))}
                                                            </Td>
                                                            <Td className="align-middle">{oi.qty}</Td>
                                                            <Td className="align-middle">
                                                              <span className={`badge ${oi.qty_unshipped > 1 ? 'p-3 bg-danger fs-4' : 'p-2 bg-info'}`}>
                                                                {oi.qty_unshipped}
                                                              </span>
                                                            </Td>
                                                            <Td className="align-middle">
                                                              <Input
                                                                type="number"
                                                                onChange={(e) => {
                                                                  const nm = { ...manifest };
                                                                  nm[oi.id].qty = parseInt(e.target.value, 10);
                                                                  setManifest(nm);
                                                                }}
                                                                className={`form-control ${manifest[oi.id] && manifest[oi.id].qty > oi.qty_unshipped ? 'is-invalid' : ''} ${manifest[oi.id] && manifest[oi.id].qty === oi.qty_unshipped ? 'bg-success bg-soft text-dark' : ''}`}
                                                                value={manifest[oi.id]?.qty}
                                                              />
                                                            </Td>
                                                          </Tr>
                                                        ))
                                                      ))}
                                                    </Tbody>
                                                  </Table>
                                                </div>
                                              </Col>
                                            </Row>
                                          )}
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                )}
                              </TabPane>
                            ))}
                          </TabContent>

                          {order && isPickup && (
                            <Card>
                              <CardHeader className="text-uppercase bg-transparent border-bottom">
                                {t('Store Pick-Up Information')}
                              </CardHeader>
                              <CardBody>
                                <p>
                                  {t('Please print two (2) invoices and deliver them without the packaging to the shelves by the Customer Service department.')}
                                  <br />
                                  <span className="text-muted">
                                    {t('Favor de imprimir dos (2) facturas y entregarlas sin el embalaje en los anaqueles por el departamento de Atención al Cliente.')}
                                  </span>
                                </p>
                                <a rel="noreferrer" href={`https://store-v5cphvs3s0.mybigcommerce.com/admin/index.php?ToDo=printOrderInvoice&orderId=${order.reference}`} target="_blank">
                                  {t('BigCommerce Invoice Link')}
                                </a>
                              </CardBody>
                            </Card>
                          )}

                          <Card>
                            <CardHeader className="text-uppercase bg-transparent border-bottom">
                              {t('Package Configuration')}
                            </CardHeader>
                            <CardBody>
                              {!isPickup && autoLabelReadiness.eligible && (
                                <Alert color="success" className="border border-success shadow-sm">
                                  <div className="d-flex align-items-center">
                                    <span className="mdi mdi-check-circle fs-2 me-2" aria-hidden="true" />
                                    <div>
                                      <strong>{t('No LPN required')}</strong>
                                      <div className="small text-success">
                                        {t('A shipping label will print automatically upon packout.')}
                                      </div>
                                      {getReadinessHistorySummary(autoLabelReadiness, t) && (
                                        <div className="small text-success mt-1">
                                          {getReadinessHistorySummary(autoLabelReadiness, t)}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Alert>
                              )}
                              {!isPickup && !autoLabelReadiness.checking && !autoLabelReadiness.eligible && autoLabelReadiness.reason && (
                                <Alert color="info" className="border border-info shadow-sm">
                                  <div className="d-flex align-items-center">
                                    <span className="mdi mdi-information-outline fs-2 me-2 text-info" aria-hidden="true" />
                                    <div>
                                      <strong className="text-info">{t('Ship page required')}</strong>
                                      <div className="small text-info">
                                        {t(getAutoLabelFailureMessage(
                                          autoLabelReadiness.reason,
                                          autoLabelReadiness.packageSource,
                                          autoLabelReadiness.detail,
                                        ))}
                                      </div>
                                      {getReadinessHistorySummary(autoLabelReadiness, t) && (
                                        <div className="small text-info mt-1">
                                          {getReadinessHistorySummary(autoLabelReadiness, t)}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Alert>
                              )}
                              <Collapse isOpen={!isPickup}>
                                <Row>
                                  <Col md="6" className="mb-3">
                                    <InputGroup>
                                      <Field name="dx" tabIndex={1} onChange={(e) => setManualPackageDimension('dx', e.target.value, values, setFieldValue)} onKeyDown={(e) => handleKeyDown(e, 'dy')} onFocus={() => { focusField(dimsXRef); }} innerRef={dimsXRef} type="text" className="form-control form-control-lg text-dark text-center" />
                                      <Field name="dy" tabIndex={2} onChange={(e) => setManualPackageDimension('dy', e.target.value, values, setFieldValue)} onKeyDown={(e) => handleKeyDown(e, 'dz')} onFocus={() => { focusField(dimsYRef); }} innerRef={dimsYRef} type="text" className="form-control form-control-lg text-dark text-center" />
                                      <Field name="dz" tabIndex={3} onChange={(e) => setManualPackageDimension('dz', e.target.value, values, setFieldValue)} onKeyDown={(e) => handleKeyDown(e, 'weight')} onFocus={() => { focusField(dimsZRef); }} innerRef={dimsZRef} type="text" className="form-control form-control-lg text-dark text-center" />
                                      <UpdateFieldWithState field="dimensions" value={`${values.dx}x${values.dy}x${values.dz}`} />
                                      <UpdateFieldWithState field="weight" value={weight} />
                                      <span className="input-group-text">{t('IN')}</span>
                                    </InputGroup>
                                    {dimensionSuggestion && (
                                      <div className="small text-muted mt-1">
                                        <strong>{`${t('Suggested package')}: ${dimensionSuggestion.packageName}`}</strong>
                                        {dimensionSuggestion.source && ` — ${t(dimensionSuggestion.source)}`}
                                      </div>
                                    )}
                                    <BoxDimsOpportunity
                                      dims={`${values.dx}x${values.dy}x${values.dz}`}
                                      weight={values.weight}
                                      carrier={autoLabelReadiness.carrier}
                                      service={autoLabelReadiness.serviceCode || autoLabelReadiness.serviceName}
                                    />
                                  </Col>
                                  <Col md="6" className="mb-3">
                                    <InputGroup>
                                      <Button type="button" color={scaleConnected ? 'warning' : 'light'} className={`btn ${scaleConnected ? 'text-dark' : 'btn-soft-warning text-dark'}`} onClick={() => { connectToScale(setFieldValue); }}>
                                        <span className="mdi mdi-scale" />
                                      </Button>
                                      <Field name="weight" tabIndex={4} onKeyDown={(e) => handleKeyDown(e, 'shipment_id')} onFocus={() => { focusField(weightRef); }} innerRef={weightRef} type="number" step=".1" className="form-control form-control-lg" />
                                      <span className="input-group-text">{t('LBS')}</span>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm="6" className="mb-3">
                                    <label htmlFor="lpn" className="form-label">
                                      {t('LPN')}
                                      {' '}
                                      <small>{t('(optional)')}</small>
                                    </label>
                                    <Field
                                      name="lpn"
                                      type="text"
                                      className="form-control"
                                    />
                                    <ErrorMessage name="lpn" component="div" className="invalid-feedback" />
                                    <UpdateFieldWithState field="lpn" value={lpn} />
                                  </Col>

                                  <Col sm="6" className="mb-3">
                                    <label htmlFor="lpn" className="form-label">{t('Order')}</label>
                                    <div className="form-control">
                                      {getCurrentPackoutOrders().map((packoutOrder) => packoutOrder.reference).join(', ')}
                                    </div>
                                    <ErrorMessage name="lpn" component="div" className="invalid-feedback" />
                                  </Col>
                                </Row>
                              </Collapse>

                              <Row className="mb-3">
                                <Col sm="6">
                                  <label htmlFor="lpn" className="form-label">{t('Packlist Notes')}</label>
                                  <Field
                                    as="textarea"
                                    name="pack_notes"
                                    className="form-control"
                                    placeholder="Note for customer. i.e. &quot;Missing a piece...&quot;"
                                  />
                                </Col>
                                <Col sm="6">
                                  <div>
                                    <label htmlFor="hazmat" className="form-label">{t('Hazmat Code')}</label>
                                    <Field
                                      as="select"
                                      name="hazmat"
                                      className={`form-control ${values.hazmat !== 0 && values.hazmat !== undefined ? 'bg-danger text-white' : ''}`}
                                    >
                                      {hazmatOptions.map((hz) => (
                                        <option value={hz.code}>{`${hz.code} - ${t(hz.description)}`}</option>
                                      ))}
                                    </Field>
                                    <UpdateFieldWithState field="hazmat" value={suggestedHazmat} />
                                  </div>
                                </Col>
                                <Col sm="6">
                                  {pourRequired && (
                                    <div className="mt-3">
                                      <label htmlFor="pour_label" className="form-label">
                                        {t('Return Label (required)')}
                                      </label>
                                      <Field
                                        name="pour_label"
                                        type="text"
                                        className="form-control"
                                      />
                                      <ErrorMessage name="pour_label" component="div" className="invalid-feedback" />
                                    </div>
                                  )}
                                  <div className="form-checkbox fs-5 mt-3">
                                    <Field name="print_packlist">
                                      {({ field }) => (
                                        <div>
                                          <Input
                                            type="checkbox"
                                            id="print_packlist"
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            {...field}
                                            checked={field.value}
                                          />
                                          <label htmlFor="print_packlist" className="ps-2">
                                            {t('Print a packlist?')}
                                          </label>
                                        </div>
                                      )}
                                    </Field>

                                    {order && order.stealth === 1 && (
                                      <Badge color="danger" className="text-white fs-4 mt-3 p-2" style={{ borderRadius: '2px' }}>
                                        <strong>{t('STEALTH')}</strong>
                                      </Badge>
                                    )}
                                  </div>
                                </Col>
                              </Row>

                              <Button type="submit" color="primary" className="btn btn-primary float-end" disabled={packSubmitting}>
                                {getPackSubmitButtonLabel(packSubmitting, isPickup, t)}
                              </Button>
                            </CardBody>
                          </Card>
                        </>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </div>
      {!isPickup && lastAutoPrintedLabel?.labelId && (
        <div
          className={classnames('pack-v2-page__reprint-drawer', {
            'pack-v2-page__reprint-drawer--open': reprintDrawerOpen,
            'pack-v2-page__reprint-drawer--warning': Boolean(lastAutoPrintedLabel.printError),
          })}
        >
          <button
            type="button"
            className="pack-v2-page__reprint-tab"
            onClick={() => setReprintDrawerOpen((previous) => !previous)}
            aria-expanded={reprintDrawerOpen}
          >
            <span className={`mdi ${reprintDrawerOpen ? 'mdi-chevron-right' : 'mdi-printer-outline'}`} aria-hidden="true" />
            <span>{t('Last Label')}</span>
          </button>
          <div className="pack-v2-page__reprint-panel">
            <div className="pack-v2-page__reprint-panel-header">
              <strong>{t('Last auto-printed label')}</strong>
              {lastAutoPrintedLabel.printError && (
                <span className="pack-v2-page__reprint-status">
                  {t('Needs reprint')}
                </span>
              )}
            </div>
            <div className="pack-v2-page__reprint-detail">
              {lastAutoPrintedLabel.trackingNumber
                ? `${t('Tracking')}: ${lastAutoPrintedLabel.trackingNumber}`
                : t('Tracking number unavailable')}
            </div>
            <div className="pack-v2-page__reprint-detail">
              {`${t('Orders')}: `}
              {Array.isArray(lastAutoPrintedLabel.orders) && lastAutoPrintedLabel.orders.length > 0 ? (
                lastAutoPrintedLabel.orders.map((packoutOrder, index) => (
                  <React.Fragment key={packoutOrder.id || packoutOrder.reference || index}>
                    {index > 0 ? ', ' : ''}
                    <Link to={`/orders/${packoutOrder.id}`}>
                      {packoutOrder.reference}
                    </Link>
                  </React.Fragment>
                ))
              ) : (
                '-'
              )}
            </div>
            {lastAutoPrintedLabel.printError && (
              <div className="pack-v2-page__reprint-warning">
                {t('Shipping label created, but automatic printing needs attention.')}
              </div>
            )}
            <Button type="button" color={lastAutoPrintedLabel.printError ? 'warning' : 'success'} className="w-100 mt-3" onClick={reprintLastAutoLabel}>
              {t('Reprint last label')}
            </Button>
          </div>
        </div>
      )}
      <Modal isOpen={incompletePackModal.open} toggle={closeIncompletePackModal}>
        <ModalHeader toggle={closeIncompletePackModal}>{t('LPN Recommended')}</ModalHeader>
        <ModalBody>
          <p style={{ whiteSpace: 'pre-wrap' }}>{incompletePackModal.message}</p>
          <div className="form-check">
            <Input
              id="incomplete-pack-acknowledge"
              type="checkbox"
              checked={incompletePackModal.acknowledged}
              onChange={(e) => {
                const { checked } = e.target;
                setIncompletePackModal((previous) => ({
                  ...previous,
                  acknowledged: checked,
                }));
              }}
            />
            <label htmlFor="incomplete-pack-acknowledge" className="form-check-label ms-2">
              {t('I understand and want to continue without an LPN.')}
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeIncompletePackModal}>{t('Cancel')}</Button>
          <Button
            color="primary"
            onClick={confirmIncompletePackOverride}
            disabled={!incompletePackModal.acknowledged || packSubmitting}
          >
            {packSubmitting ? t('Packing...') : t('Continue Packout')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

function UpdateFieldWithState({ field, value }) {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    // Update form field 'myField' whenever stateVariable changes
    setFieldValue(field, value);
  }, [field, value]);

  return null; // This component does not render anything
}

function AutoLabelReadinessWatcher({
  activeOrderIds,
  activeOrders,
  dx,
  dy,
  dz,
  weight,
  isPickup,
  setAutoLabelReadiness,
}) {
  useEffect(() => {
    if (isPickup || !Array.isArray(activeOrderIds) || activeOrderIds.length === 0) {
      setAutoLabelReadiness({
        checking: false,
        eligible: false,
        reason: null,
        packageSource: null,
        detail: null,
        dimensions: null,
        weight: null,
        historicalPackedBy: null,
        carrier: null,
        serviceCode: null,
        serviceName: null,
      });
      return undefined;
    }

    if (Array.isArray(activeOrders) && activeOrders.some((activeOrder) => Number(activeOrder?.shipped) === 1)) {
      setAutoLabelReadiness({
        checking: false,
        eligible: false,
        reason: 'already_shipped',
        packageSource: null,
        detail: null,
        dimensions: null,
        weight: null,
        historicalPackedBy: null,
        carrier: null,
        serviceCode: null,
        serviceName: null,
      });
      return undefined;
    }

    let cancelled = false;
    const timeoutId = window.setTimeout(async () => {
      setAutoLabelReadiness((previous) => ({
        ...previous,
        checking: true,
      }));

      try {
        const result = await post('/api/warehouse/pack/auto-label-readiness', {
          order_ids: activeOrderIds,
          dx,
          dy,
          dz,
          weight,
        });

        if (!cancelled) {
          setAutoLabelReadiness({
            checking: false,
            eligible: result?.eligible === true,
            reason: result?.reason || null,
            packageSource: result?.package_source || null,
            detail: result?.detail || result?.error || null,
            dimensions: result?.dimensions || null,
            weight: result?.weight || null,
            historicalPackedBy: result?.historical_packed_by || null,
            carrier: result?.carrier || null,
            serviceCode: result?.service_code || null,
            serviceName: result?.service_name || null,
          });
        }
      } catch (error) {
        if (!cancelled) {
          const failureDetail = error.response?.data?.error || error.message || 'Unable to check label readiness.';
          setAutoLabelReadiness({
            checking: false,
            eligible: false,
            reason: 'error',
            packageSource: null,
            detail: failureDetail,
            dimensions: null,
            weight: null,
            historicalPackedBy: null,
            carrier: null,
            serviceCode: null,
            serviceName: null,
          });
        }
      }
    }, 350);

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [activeOrderIds.join(','), dx, dy, dz, weight, isPickup, setAutoLabelReadiness]);

  return null;
}

PackV2.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

const mapStateToProps = (state) => ({ ...state.Layout });

export default connect(mapStateToProps, {
  changeSidebarType,
})(withTranslation()(PackV2));
